// page_name##页面名称(1:商品详情页)
const page_name = 1
export default {
  /** 华丽的分割线-开始 */

  // menu_list##titlebar曝光菜单列表，多个菜单名以|拼接为字符串，如商品|评价|详情
  // page_name##页面名称(1:商品详情页)
  // sku_id##商品skuid
  // share_content##分享按钮内容id(1:分享按钮无礼品角标，为普通分享;2:分享按钮有礼品角标，为推荐有礼)
  // status##状态(default:默认未滑动;slided:滑动后)
  titlebarShow: ({ sku_id, share_content, status, menu_list }) => ({
    act: 'show',
    params: {
      cfrom: '170|001|02|077',
      event_id: '170|001|02|077',
      menu_list: menu_list && menu_list.filter(item => item).join('|'),
      page_name,
      sku_id,
      share_content,
      status: status ? 'slided' : 'default'
    }
  }),

  // 点击titlebar时上报：
  // sku_id##商品skuid&&
  // titlebar_content##titlebar按钮内容id, 1 -7 (1：返回、2：商品、3：评价、4：详情、5：推荐、6：分享、7：汉堡菜单) &&
  // page_type##页面类型(0:正常页面;1:秒杀页面;2:抢购进行中-有氛围;3:抢购进行中-无氛围;4:抢购进行中-共存;5:定金预售;6:全款预定;7:常规拼购;8:会员优先购;9:大促氛围)&&
  // page_name##页面名称(1:商品详情页)
  titlebarClick: ({ sku_id, titlebar_content, page_type }) => ({
    act: 'click',
    params: { cfrom: '170|001|01|077', event_id: '170|001|01|077', page_name, sku_id, titlebar_content, page_type }
  }),

  // 浏览记录曝光、点击
  // page_name##页面名称(1:商品详情页)&&
  // spu_id##浏览记录商品spuid&&
  // sku_id##主商品skuid&&
  // position##位置
  history: ({ spu_id, sku_id, position }) => [
    {
      act: 'show',
      params: { cfrom: '170|003|02|077', event_id: '170|003|02|077', page_name, spu_id, sku_id, position }
    },
    {
      act: 'click',
      params: { cfrom: '170|003|01|077', event_id: '170|003|01|077', page_name, spu_id, sku_id, position }
    }
  ]

  /** 华丽的分割线-结束 */
}
